<template>
  <div>
    <div class="d-flex">
      <v-autocomplete
        :disabled="disabled"
        :color="color"
        :dense="dense"
        :outlined="outlined"
        :hide-details="hideDetails"
        :items="countries"
        class="country-select"
        item-value="code"
        single-line
        :filter="
          (item, query) =>
            item?.name?.toLocaleLowerCase().indexOf(query.toLocaleLowerCase()) > -1 ||
            item?.dial_code?.toLocaleLowerCase().indexOf(query.toLocaleLowerCase()) > -1
        "
        v-model="activeCountry"
        no-data-text="No countries found"
      >
        <template v-slot:selection="{ item }"> {{ item.code }} {{ item.dial_code }} </template>
        <template v-slot:item="{ item }">
          <span>{{ item.flag }} {{ item.name }} {{ item.dial_code }} </span>
        </template>
      </v-autocomplete>
      <v-text-field
        v-model="phone"
        :value="value"
        :label="label"
        :placeholder="placeholder"
        :disabled="disabled"
        :color="color"
        :outlined="outlined"
        :dense="dense"
        :clearable="clearable"
        :hide-details="hideDetails"
        :style="textFieldStyle"
        :class="textFieldClass"
        :rules="rules"
        class="phone-input"
        @input="onInput"
      ></v-text-field>
      <!-- {{ phoneObject }} -->
    </div>
  </div>
</template>

<script>
// import * as countryFlags from "country-flag-icons/unicode";
// import CountryList from "country-list-with-dial-code-and-flag";
import CountryList from "@/shared_data/country-codes";
import * as libPhoneNumber from "libphonenumber-js";

export default {
  name: "PhoneNumber",
  // input: (nationalText, phoneObject, rawFieldText) on every edit and on a country change.
  // validate: (phoneObject) when validity flips, or when the field resets from a new value.
  emits: ["input", "validate"],
  props: {
    value: {},
    color: {
      type: String,
      default: "brandCyan",
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    textFieldStyle: {
      type: String,
    },
    textFieldClass: {
      type: String,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formValid: false,
      menu: false,
      countries: CountryList,
      // countryCode: "+1",
      activeCountry: "US",
      phone: "",
      // flags: countryFlags
    };
  },
  created() {},
  mounted() {
    this.reset(true);
  },
  methods: {
    reset(init = false) {
      console.log("Calling reset", init);
      if (this.value) {
        this.phone = this.value.trim();

        // Now remove the country code if it's there
      }
      this.initializeCountry()
        .then(() => {
          // if (
          //   !this.phone &&
          //   this.inputOptions &&
          //   this.inputOptions.showDialCode &&
          //   this.activeCountry.dialCode
          // ) {
          //   this.phone = `+${this.activeCountry.dialCode}`;
          // }
          // Now remove the country code if it's there
          if (this.phone && this.phone[0] === "+") {
            const phone = libPhoneNumber.parsePhoneNumberFromString(this.phone);
            this.phone = phone?.nationalNumber || "";
          }
          // this.countryCode = this.activeCountry;
          if (!init) this.$emit("validate", this.phoneObject);
        })
        .catch(console.error);
      // .finally(() => {
      //   this.finishMounted = true;
      // });
    },
    initializeCountry() {
      return new Promise((resolve) => {
        /**
         * 1. If the phone included prefix (+12), try to get the country and set it
         */
        console.log("this.phone", this.phone);
        if (this.phone && this.phone[0] === "+") {
          const activeCountry = libPhoneNumber.parsePhoneNumberFromString(this.phone)?.country;
          console.log(activeCountry);
          if (activeCountry) {
            this.activeCountry = activeCountry;
            // this.choose(activeCountry);
            resolve();
            return;
          }
        }
        /**
         * 2. Use default country if passed from parent
         */
        this.activeCountry = "US";
        resolve();
        return;
      });
    },
    onInput() {
      // this.$refs.input.setCustomValidity(
      //   this.phoneObject.valid ? "" : this.invalidMsg
      // );
      // Returns response.number to assign it to v-model (if being used)
      // Returns full response for cases @input is used
      // and parent wants to return the whole response.
      // Third argument is the raw text currently in the field: `phoneText` is empty for
      // anything libphonenumber cannot parse at all ("4", "abc"), so a parent cannot use
      // it to tell an empty field from one holding junk.
      this.$emit("input", this.phoneText, this.phoneObject, this.phone);
    },
  },
  computed: {
    phoneObject() {
      const result = libPhoneNumber.parsePhoneNumberFromString(
        this.phone || "",
        this.activeCountry
      );
      console.log("Phone object", result);
      console.log("Valid", result?.isValid());
      Object.assign(result || {}, {
        isValid: !!result?.isValid() || false,
        // number: result?.number || "",
        country: this.activeCountry,
      });
      if (!this.phone) {
        return {
          isValid: false,
          ...result,
          number: "",
        };
      }
      return result || {};
    },
    phoneText() {
      // let key = "input";
      // if (this.phoneObject.valid) {
      //   key = this.parsedMode;
      // }
      // return this.phoneObject.number[key] || "";
      const val =
        !this.phoneObject || !this.phoneObject.formatNational
          ? ""
          : this.phoneObject?.formatNational() || "";

      return val;
    },
  },
  watch: {
    activeCountry() {
      // Update country code
      // let code;
      // if (newValue)
      //   code = CountryList?.findOneByCountryCode(newValue)?.dial_code;
      // if (!code) code = "+1";
      // this.countryCode = code;

      // Emit an event if they change countries
      this.onInput();
      this.$emit("validate", this.phoneObject);
    },
    value() {
      // this.phone = this.value;
      this.reset();
    },
    "phoneObject.isValid": function (value) {
      if (value) {
        this.phone = this.phoneText;
      }
      console.log("Emitting validate event", this.phoneObject);
      this.$emit("validate", this.phoneObject);
    },
    // phone(newValue, oldValue) {
    //   if (newValue) {
    //     if (newValue[0] === '+') {
    //       const code = PhoneNumber(newValue).getRegionCode();
    //       if (code) {
    //         this.activeCountry = this.findCountry(code) || this.activeCountry;
    //       }
    //     }
    //   }
    //   // Reset the cursor to current position if it's not the last character.
    //   if (oldValue && this.cursorPosition < oldValue.length) {
    //     this.$nextTick(() => {
    //       setCaretPosition(this.$refs.input, this.cursorPosition);
    //     });
    //   }

    //   this.$emit('input', this.phoneText, this.phoneObject);
    // },
  },
};
</script>

<style scoped>
.country-select {
  max-width: 145px;
  min-width: 85px;
  margin-right: 8px;
}
.phont-input {
  min-width: 115px;
  width: 100%;
}
</style>
